import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import { handleChange } from "../../../helpers/handleFormChanges";
import CommonInput from "../../../components/forms/CommonInput";
import PropTypes from "prop-types";

function EnviarEmailModal({ modalHook, valuesHook, enviarEmails }) {
  const { enviarEmailModal, setEnviarEmailModal } = modalHook;
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title="Enviar NFS-e por e-mail"
      is_open_modal={enviarEmailModal}
      set_is_open_modal={setEnviarEmailModal}
      size="lg"
      buttons={[
        <button
          key={`enviar-emails`}
          type="button"
          onClick={() => {
            enviarEmails();
          }}
          className="btn btn-success"
        >
          Enviar e-mail
        </button>,
      ]}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          enviarEmails();
        }}
      >
        <div className="row">
          <div className="col-12 mb-3">
            <CommonInput
              label="E-mails"
              id="emails"
              value={values.emails}
              onChange={(e) => handleChange(e, values, setValues)}
            />
            <small>
              Se precisar adicionar mais e-mails, por favor, insira-os separados
              por vírgula(,)
            </small>
          </div>
        </div>
      </form>
    </CommonModal>
  );
}

EnviarEmailModal.propTypes = {
  modalHook: PropTypes.shape({
    enviarEmailModal: PropTypes.bool.isRequired,
    setEnviarEmailModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  enviarEmails: PropTypes.func.isRequired,
};

export default EnviarEmailModal;
